import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow bg-white pt-20 md:pt-24">
        <div className="container mx-auto px-6 md:px-4 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-medium text-gray-800 mb-4 font-trends">
              Privacy Policy
            </h1>
            <h2 className="text-xl sm:text-2xl text-gray-800 mb-6 font-trends">
              Chase the Chickens
            </h2>
            <p className="text-gray-600 mb-8">Effective Date: January 12, 2025</p>

            <p className="text-lg md:text-xl text-gray-800 mb-8">
              At Rock Software, your privacy is a top priority. This Privacy Policy outlines how we collect, use, and protect your information when you use the Chase the Chickens website and app. By using our services, you agree to the practices described below.
            </p>

            {/* Sections */}
            <div className="space-y-8 md:space-y-12">
              {/* Information Collection */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">1. Information We Collect</h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Personal Information:</strong> When you sign up, we may collect your name, email address, and payment details for account creation and in-game transactions.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Usage Information:</strong> We collect information about how you interact with the app, including game activities, preferences, and settings.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Device Information:</strong> We gather technical information such as your IP address, device type, operating system, and browser type.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Location Data:</strong> The app requires location data to facilitate gameplay features, such as tracking and boundary settings.</span>
                  </li>
                </ul>
              </section>

              {/* Usage of Information */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">2. How We Use Your Information</h2>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>To operate and improve the game, including gameplay management, tracking, and notifications.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>To process payments and manage your account.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>To send updates, promotional offers, and important service-related notifications.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span>To ensure security and prevent misuse of the app.</span>
                  </li>
                </ul>
              </section>

              {/* Similar sections for 3-7... */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">3. Sharing Your Information</h2>
                <p className="text-gray-600 mb-4">We do not sell or rent your data. However, we may share your information with:</p>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Service Providers:</strong> To assist with payment processing, app hosting, and customer support.</span>
                  </li>
                  <li className="flex space-x-3">
                    <span className="text-[#E57373] mt-1.5">•</span>
                    <span><strong>Legal Authorities:</strong> When required by law or to protect our rights.</span>
                  </li>
                </ul>
              </section>

              {/* Contact Section */}
              <section>
                <h2 className="text-2xl font-medium text-gray-800 mb-4">Contact Us</h2>
                <p className="text-gray-600 mb-4">If you have questions about this Privacy Policy, please contact us at:</p>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Email:</strong> privacy@chasethechickens.co.uk</p>
                  <p><strong>Mail:</strong> Rock Software, 123 Game Street, London, UK</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;